import { useMemo } from "react";
import { useSelector } from "services/redux/rootReducer";

interface Props {
    unfilteredInitialSuggestions: string[];
}

const useFilteredInitialSuggestions = ({
    unfilteredInitialSuggestions,
}: Props) => {
    const tags = useSelector((state) => state.tags);

    const filteredInitialSuggestions = useMemo(() => {
        return unfilteredInitialSuggestions.filter((initialSuggestion) =>
            tags.find(({ key }) => key.startsWith(initialSuggestion))
        );
    }, [tags, unfilteredInitialSuggestions]);

    return [filteredInitialSuggestions] as const;
};

export default useFilteredInitialSuggestions;
